import "../css/NewPost.css"
import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

interface post {
  title: string;
  date: string;
  text: string;
  image: string[];
}

export const NewPost = () => {
  const [posts, setPosts] = useState<post[]>([]);
  const history = useHistory();

  const openDetailClick = (index: number) => {
    console.log("test")
    history.push(`/BlogDetail/${index}`);
  };
  useEffect(() => {
    // JSONファイルを読み込む
    fetch("../../static-data/blog_data.json")
      .then((response) => response.json())
      .then((data) => {
        setPosts(data); // 取得したデータをstateに保存
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, []); // コンポーネントがマウントされたときに実行
  const firstThreePosts = Object.values(posts).slice(0, 3);
  const defaultImage = '../../static-data/default-image.webp'; // デフォルト画像のパス
  return (
    <>
      <div className="image-container">
        {Object.values(firstThreePosts).map((post, index) => (
          <div key={index}
            onClick={() => openDetailClick(index)}>
            <div className="image-container-mobile">
              <img
                src={post.image.length > 0 ? post.image[0] : defaultImage}
                alt={`First of ${post.title}`}
                className="image"
              />
              <span className="overlay-text">{post.title}</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
